module.exports = __webpack_public_path__ + "img/memo.dd4a73e1.png";